import { Injectable } from "@angular/core";
import { RequestMethodsService } from "../../commons/request_methods";
import { Constants } from "../../commons/constants";
import { Platform,NavController,AlertController } from "ionic-angular";
import { Storage } from "@ionic/storage";
import { LoginPage } from "../login/login";
import { SecurityConfiguration } from "../../security/security.configuration";

@Injectable()
export class HomeService {

    public access_token: string;
    public customerList: any = [];

    private colorCodes: string[] = ["#666666", "#006400", "#FFFF00", "#FFA500", "#ff0000"]; //Never ever change this array

    constructor(
        private requestMethodService: RequestMethodsService,
        private constants: Constants,
        private storage: Storage,
        private platform: Platform,
        // private navCtrl:NavController,
        private alertCtrl:AlertController,
        private securityConfig:SecurityConfiguration
    ) {

    }

    getColorCodeForCustomer(customer) {
        if (customer && customer.children && customer.children.length > 0) {
            let projects = customer.children;
            let assets = [];
            projects.forEach(project => {
                if (project.children && project.children.length > 0) {
                    assets = assets.concat(project.children);
                }
            })
            let assetColorCodes = assets.map((el) => el.colortypecode);
            let max = Math.max.apply(Math, assetColorCodes);
            return this.colorCodes[max];
        }
    }

    getColorCodeForProject(project) {
        if (project && project.children && project.children.length > 0) {
            let assets = project.children;
            let assetColorCodes = assets.map((el) => el.colortypecode);
            let max = Math.max.apply(Math, assetColorCodes);
            return this.colorCodes[max];
        }
    }

    getColorCodeForAsset(asset) {
        return this.colorCodes[asset.colortypecode];
    }

    getCustomersFromTreeStructure(treeStructure: any = [], x: string) {
        treeStructure.forEach(element => {
            if (element.type && element.type.toLowerCase() == x) {
                this.customerList.push(element);
            }
            else {
                if (element.children && element.children.length > 0) {
                    this.getCustomersFromTreeStructure(element.children, 'customer');
                }
            }
        });
        return this.customerList;
    }

    getDataSourceForUser(token) {
        return this.requestMethodService.get(token,
            this.constants.BASE_URL,
            this.constants.GetDataSourceForUser);
    }

    getUserDetails(token, username) {
        return this.requestMethodService.get(token,
            this.constants.BASE_URL,
            this.constants.GET_USER_DETAILS,
            {
                username: username
            });
    }
    GetLangauges(token){
        return this.requestMethodService.get(token,
            this.constants.BASE_URL,
            this.constants.GET_Langauges,
        );
    }

    getBranchDetails(token, username) {
        return this.requestMethodService.get(token,
            this.constants.BASE_URL,
            this.constants.GET_BRANCH_DETAILS,
            {
                id: username
            });
    }

    getTreeStructureData(token, username) {
        return this.requestMethodService.get(
            token,
            this.constants.BASE_URL,
            this.constants.GET_TREE_STRUCTURE,
            {
                id: username
            });
    }

    getFavouriteCustomers(token, username) {
        return this.requestMethodService.get(
            token,
            this.constants.BASE_URL,
            this.constants.GET_FAVOURITE_CUSTOMERS,
            {
                id: username
            });
    }

    filterFavourites(favCustomers, treeStructure) {
        let filteredArr = [];
        if (favCustomers.CustomerDetails && favCustomers.CustomerDetails.length > 0) {
            let favCustomerArray = favCustomers.CustomerDetails;
            treeStructure.forEach(el => {
                if (favCustomerArray.indexOf(el.id) >= 0) {
                    if (!(filteredArr.find((element) => element.id == el.id))) {
                        filteredArr.push(el);
                    }
                }
            })
        }
        return filteredArr;
    }

    saveCustomersToFavourite(token, body) {
        return this.requestMethodService.post(
            token,
            this.constants.BASE_URL + this.constants.SAVE_FAVOURITE_CUSTOMERS,
            body
        );
    }

    resetCustomerList() {
        this.customerList.length = 0;
    }

    areSitesMapped(array) {
        let flag = false;
        for (let i = 0; i < array.length; i++) {
            if (array[i].children && array[i].children.length > 0) {
                flag = true;
                break;
            }
        }
        return flag;
    }

    GetAgreementCheckDetails(token, username) {
        return this.requestMethodService.get(token,
            this.constants.BASE_URL,
            this.constants.GET_AGREEMENT_CHECK_DETAILS,
            {
                id: username
            });
    }

    // checkSessionTimeout() {
    //     let alert = this.alertCtrl.create({
    //         title: 'Session Timeout',
    //         subTitle: 'Your session timed out. Please login again',
    //         buttons: [
    //             {
    //                 text: 'Ok',
    //                 handler: () => {
    //                     this.logout()
    //                 }
    //             }
    //         ]

    //     });
    //     alert.present();
    // }

    // logout() {
    //     if (this.platform.is("mobileweb") || this.platform.is("core")) {
    //         this.securityConfig.logout();
    //     }
    //     else {
    //         this.storage.clear().then((clear) => {
    //             this.resetCustomerList();
    //             this.navCtrl.setRoot(LoginPage);
    //         })
    //     }
    // }
}




// WEBPACK FOOTER //
// ./src/pages/home/home.service.ts